<template>
  <div>
    <p class="text-right">
      <router-link :to="{ name: 'designations.create' }" class="btn btn-primary">
        <font-awesome-icon :icon="['fal', 'plus-circle']" />
        Create
      </router-link>
    </p>

    <div ref="tree" class="org-chart"></div>
  </div>
</template>

<script type="text/babel">
import OrgChart from "@/imports/orgchart";

export default {
  data() {
    return {
      nodes: [],
      highlightedUser: null,
    };
  },

  async created() {
    let url = "/designations?limit=99999999";
    if (this.$router.currentRoute.query.user_id) {
      url += `&user_id=${this.$router.currentRoute.query.user_id}`;
    }

    const response = await this.$http.get(url);

    // Get highlighted user info is ?user_id=ID is present in the URL
    this.highlightedUser = await this.getHighlightedUser();
    let highlightedDesignationId = null;
    if (this.highlightedUser) {
      highlightedDesignationId = this.highlightedUser.designation.id;
    }

    if (response.status === 200) {
      this.nodes = response.body.data.map((item) => {
        if (highlightedDesignationId && highlightedDesignationId === item.id) {
          return {
            id: item.id,
            name: item.name,
            pid: item.parent_id === 0 ? "" : item.parent_id,
            user: this.highlightedUser,
            user_name: this.highlightedUser.name,
            tags: ["HighlightedUser"],
          };
        }

        return {
          id: item.id,
          name: item.name,
          pid: item.parent_id === 0 ? "" : item.parent_id,
        };
      });

      this.init(this.$refs.tree, this.nodes);
    }
  },

  methods: {
    init(dom, nodes) {
      OrgChart.templates.highlighting = Object.assign({}, OrgChart.templates.ana);

      OrgChart.templates.bolt = Object.assign({}, OrgChart.templates.ana);
      OrgChart.templates.bolt.ripple = {
        radius: 0,
        color: "none",
        rect: null,
      };
      OrgChart.templates.bolt.node =
        "<rect x='0' y='0' height='{h}' width='{w}' fill='#1e90c6' stroke-width='1' stroke='#ffffff' rx='7' ry='7'></rect>";
      OrgChart.templates.bolt.editFormHeaderColor = "#1e90c6";

      OrgChart.templates.bolt.field_0 =
        "<switch>" +
        '<foreignObject x="0" y="0" width="250" height="100%">' +
        '<div xmlns="http://www.w3.org/1999/xhtml" style="font-size: 20px; color: #fff; width: 250px; height: 120px; text-align: center; display: table-cell; vertical-align: middle; padding-left: 20px; padding-right: 20px; cursor: pointer; font-weight: bold">{val}</div>' +
        "</foreignObject>" +
        "</switch>";

      OrgChart.templates.bolt.field_1 =
        "<switch>" +
        '<foreignObject x="0" y="0" width="250" height="100%">' +
        '<div xmlns="http://www.w3.org/1999/xhtml" style="font-size: 20px; color: #fff; width: 250px; height: 120px; text-align: center; display: table-cell; vertical-align: middle; padding-left: 20px; padding-right: 20px; cursor: pointer; font-weight: bold">{val}</div>' +
        "</foreignObject>" +
        "</switch>";

      this.chart = new OrgChart(dom, {
        template: "bolt",
        enableSearch: false,
        nodes: nodes,
        nodeBinding: {
          field_0: "name",
          field_1: "user_name",
        },
        tags: {
          HighlightedUser: {
            template: "highlighting",
          },
        },
        nodeMenu: {
          delete: {
            icon: OrgChart.icon.remove(18, 18, "#1e90c6"),
            text: "Delete",
            onClick: (id) => {
              window
                .sweetAlert({
                  title: "Are you sure?",
                  text: "Are you sure that you want to delete this designation?",
                  icon: "warning",
                  dangerMode: true,
                  buttons: {
                    cancel: "No",
                    confirm: "Yes, delete!",
                  },
                })
                .then(async (confirmed) => {
                  if (confirmed) {
                    try {
                      await this.$http.delete(`/designations/${id}`);

                      this.chart.removeNode(id);
                    } catch (error) {
                      const message = this.$lodash.get(
                        this.$lodash.values(error.body.errors),
                        "[0][0]",
                        null
                      );
                      if (message) {
                        window.sweetAlert({
                          title: "Failed to delete",
                          text: message,
                          icon: "error",
                        });
                      }
                    }
                  }
                });
            },
          },
        },
      });
      this.chart.on("click", (sender, args) => {
        this.$router.push({
          name: "designations.edit",
          params: { id: args.node.id },
        });

        return false;
      });
    },

    async getHighlightedUser() {
      if (this.$router.currentRoute.query.user_id) {
        const highlightedUser = await this.$http.get(
          `/users/${this.$router.currentRoute.query.user_id}?with=designation`
        );

        if (highlightedUser.body.designation.id) {
          return highlightedUser.body;
        }
      }

      return null;
    },
  },
};
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
.org-chart {
  height: calc(100vh - 190px);
}
</style>
